// src/pages/auth/SignUp.js
import React from "react";
import styled from "@emotion/styled";
import { Helmet } from "react-helmet-async";
import { Link } from "react-router-dom"; // Import Link

import { Paper, Typography } from "@mui/material";

// import { ReactComponent as Logo } from "../../vendor/logo.svg";
import Logo from "../../vendor/instaconnect_half_logo.png";
import SignUpComponent from "../../components/auth/SignUp";

const Brand = styled.img`
  width: 64px;
  height: 64px;
  margin-bottom: 32px;
  display: block;
`;

const Wrapper = styled(Paper)`
  padding: ${(props) => props.theme.spacing(6)};

  ${(props) => props.theme.breakpoints.up("md")} {
    padding: ${(props) => props.theme.spacing(10)};
  }
`;

function SignUp() {
  return (
    <React.Fragment>
      <Link to="/">
        <Brand src={Logo} alt="InstaConnect Logo" />
      </Link>
      <Wrapper>
        <Helmet title="Sign Up" />

        <Typography component="h1" variant="h4" align="center" gutterBottom>
          Get started
        </Typography>
        <Typography
          component="h2"
          variant="body1"
          align="center"
          sx={{ mb: 4 }}
        >
          Start creating the best possible user experience for your customers
        </Typography>

        <SignUpComponent />
      </Wrapper>
    </React.Fragment>
  );
}

export default SignUp;
